// Constants
const SET_PAGE_TITLE = 'main/SET_PAGE_TITLE';

// Initiual State
const initialState = {
  title: null
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  if (action.type === SET_PAGE_TITLE) {
    state.title = action.payload.value;

    return { ...state };
  }

  return state;
}

// Action Creators
export function setPageTitle(value) {
  return (dispatch) => {
    dispatch({ type: SET_PAGE_TITLE, payload: { value } });
  };
}
